import { MediaRelease } from "@jesus-central-church/ui";
import { SbMediaRelease } from "@storyblok/types/287435740670216/storyblok-components";

export function MediaReleaseComponent({ blok }: { blok: SbMediaRelease }) {
  return (
    <MediaRelease
      subtitle={blok.subtitle}
      title={blok.title}
      description={blok.description}
      youtubeUrl={blok.youtubeUrl?.url}
      spotifyUrl={blok.spotifyUrl?.url}
    />
  );
}
